<!-- If you change the layout or the heights of the any group/product related html -->
<!-- Go into the Inventory-view-model-helper.ts and update the item heights -->

<!-- General Templates -->
<ng-template #icon>
  <ion-icon
    name="information-circle"
    class="info-icon"
    [class.price-override]="inventoryItem?.overrideFlag"
    [class.catch-weight]="
      inventoryItem.productCatchWeightFlag &&
      !inventoryItem.productBadPricingUnitFlag
    "
    [class.bad-pricing]="
      inventoryItem.productBadPricingUnitFlag ||
      inventoryItem.productBadPricingCaseFlag
    "
    (click)="handleInfoIconClick()"
  ></ion-icon>
</ng-template>
<ng-template #itemDetails>
  <div
    data-cy="inventory-card-title-section"
    class="inventory-product-title"
    *ngIf="!inventoryItem?.productMissingFlag"
  >
    <span
      (click)="handleProductDescriptionClick()"
      data-cy="inventory-card-title-text"
      *ngIf="inventoryItem?.nonUSFFlag"
    >
      <span class="non-usf-ind" data-cy="inventory-card-title-text-non-usf">
        {{ 'Non-USF: ' }}
      </span>
      {{
        inventoryItem?.productName | acronymTitleCase | truncateWithEllipsis: 55
      }}
    </span>
    <span
      (click)="handleProductDescriptionClick()"
      data-cy="inventory-card-title-text"
      *ngIf="!inventoryItem?.nonUSFFlag"
    >
      {{ inventoryItem?.productName | acronymTitleCase }}
    </span>
  </div>
  <div
    data-cy="inventory-card-title-section"
    class="inventory-product-title"
    *ngIf="inventoryItem?.productMissingFlag"
  >
    <span
      (click)="handleProductDescriptionClick()"
      data-cy="inventory-card-title-text"
      class="missing-product"
    >
      {{ 'i18n.inventory.inventoryCardMissingProduct' | translate }}
    </span>
  </div>

  <div
    data-cy="inventory-edit-card-num-pack-size-section"
    class="inventory-product-num-pack-size"
  >
    <p data-cy="inventory-edit-card-product-number">
      #{{ inventoryItem?.productNumber }}
    </p>
    <img
      *ngIf="inventoryItem?.productPackSizeLabel"
      data-cy="inventory-edit-card-separator-image"
      src="assets/images/separator.png"
      class="inventory-card-separator-image"
    />
    <p data-cy="inventory-edit-card-sales-pack-price">
      {{ inventoryItem?.productPackSizeLabel }}
    </p>
    <img
      *ngIf="inventoryItem?.productBrand"
      data-cy="inventory-edit-card-separator-image-brand"
      src="assets/images/separator.png"
      class="inventory-card-separator-image"
    />
    <p data-cy="inventory-edit-card-brand-name">
      {{ inventoryItem?.productBrand | acronymTitleCase }}
    </p>
  </div>
</ng-template>

<ng-template #group>
  <ion-item
    id="group-{{ inventoryId }}-{{ index }}"
    data-cy="inventory-edit-card-change-group-button"
    detail="true"
    detail-icon="caret-down-outline"
    (click)="handleGroupEvent($event)"
    [disabled]="inventoryItem.isSelected"
    globalkeyhandler="input"
  >
    <ion-label data-cy="inventory-edit-card-change-group-button-label">
      {{ inventoryItem?.groupName | truncateWithEllipsis: 15 }}
    </ion-label>
  </ion-item>
</ng-template>

<ng-template #unitDescription>
  <p
    class="missed-item-update regular-font-weight"
    [class.visible]="
      !!inventoryItem?.missedItemUpdates &&
      (inventoryItem.missedItemUpdates['convFactorUnit'] ||
        inventoryItem.missedItemUpdates['productUnitOfMeasure'])
    "
    data-cy="updated-unit-description-text"
  >
    {{ 'i18n.common.updated' | translate }}!
  </p>
  <ion-item
    id="description-{{ inventoryId }}-{{ index }}"
    data-cy="inventory-edit-card-change-uom-button"
    [attr.detail]="inventoryItem.productCatchWeightFlag ? false : true"
    detail-icon="caret-down-outline"
    [disabled]="inventoryItem.isSelected"
    (click)="handleUOMEvent($event)"
    globalkeyhandler="input"
  >
    <ion-label data-cy="inventory-edit-card-change-uom-button-label">
      {{ inventoryItem?.uom }}
    </ion-label>
  </ion-item>
</ng-template>

<ng-template #unitByCase>
  <p
    class="missed-item-update regular-font-weight missed-item-update-unit-by-case"
    [class.visible]="
      !!inventoryItem?.missedItemUpdates &&
      (inventoryItem.missedItemUpdates['invConvFactor'] ||
        inventoryItem.missedItemUpdates['productConvFactor'])
    "
    data-cy="updated-unit-by-case-text"
  >
    {{ 'i18n.common.updated' | translate }}!
  </p>
  <ion-input
    *ngIf="!inventoryItem.productCatchWeightFlag; else notApplicableCA"
    id="cs-{{ inventoryId }}-{{ index }}"
    data-cy="inventory-edit-card-unit-by-case-input"
    inputmode="numeric"
    maxlength="5"
    type="text"
    [disabled]="inventoryItem.isSelected"
    [value]="inventoryItem.displayConvFactor"
    (ionBlur)="handleConversionFactorEvent($event)"
    (ionFocus)="handleConversionFactorFocus()"
    [maxLeftHandDigits]="3"
    [maxPrecision]="2"
    customDecimal
    [ngClass]="inventoryItem.isSelected ? 'disabled' : ''"
    globalkeyhandler="input"
  >
  </ion-input>
  <ng-template #notApplicableCA>
    <ion-input
      data-cy="inventory-edit-card-unit-by-case-input"
      class="not-applicable-input"
      placeholder="{{ 'i18n.common.notApplicable' | translate }}"
      [disabled]="true"
      (click)="
        platform !== PlatformEnum.desktop
          ? handleCatchWeightHover($event)
          : undefined
      "
      (mouseover)="
        platform === PlatformEnum.desktop
          ? handleCatchWeightHover($event)
          : undefined
      "
      (mouseleave)="
        platform === PlatformEnum.desktop ? handleCatchWeightLeave() : undefined
      "
      [ngClass]="inventoryItem.isSelected ? 'disabled' : ''"
      [class.catchweight]="inventoryItem.productCatchWeightFlag"
    >
    </ion-input>
  </ng-template>
</ng-template>

<ng-template #price>
  <p
    class="missed-item-update regular-font-weight missed-item-update-price"
    [class.visible]="
      !!inventoryItem?.missedItemUpdates &&
      (inventoryItem.missedItemUpdates['overrideCasePrice'] ||
        inventoryItem.missedItemUpdates['priceOverrideInd'] ||
        inventoryItem.missedItemUpdates['productUnitPrice'] ||
        inventoryItem.missedItemUpdates['productCasePrice'])
    "
    data-cy="updated-price-text"
  >
    {{ 'i18n.common.updated' | translate }}!
  </p>
  <div
    *ngIf="!inventoryItem.productCatchWeightFlag; else productCatchWeight"
    data-cy="inventory-edit-card-price-section"
    class="inventory-price-section"
  >
    <ion-input
      id="price-{{ inventoryId }}-{{ index }}"
      *ngIf="inventoryItem?.casePrice !== -1; else noCasePrice"
      data-cy="inventory-edit-card-case-price-input"
      inputmode="decimal"
      [disabled]="inventoryItem.isSelected"
      [value]="
        priceIsBeingInteracted
          ? inventoryItem.casePrice
          : (inventoryItem.casePrice | currency)
      "
      (ionBlur)="handlePriceOverrideEvent($event)"
      (ionFocus)="handlePriceFocus()"
      customDecimal
      [maxLeftHandDigits]="6"
      [maxPrecision]="2"
      [ngClass]="inventoryItem.isSelected ? 'disabled' : ''"
      globalkeyhandler="input"
    >
    </ion-input>
    <ng-template #noCasePrice>
      <ion-input
        id="price-{{ inventoryId }}-{{ index }}"
        data-cy="inventory-edit-card-case-price-not-found-input"
        class="override"
        inputmode="decimal"
        placeholder="$0.00"
        [disabled]="inventoryItem.isSelected"
        (ionBlur)="handlePriceOverrideEvent($event)"
        (ionFocus)="handlePriceFocus()"
        customDecimal
        [maxLeftHandDigits]="6"
        [maxPrecision]="2"
        [ngClass]="inventoryItem.isSelected ? 'disabled' : ''"
        globalkeyhandler="input"
      >
      </ion-input>
    </ng-template>
    <p class="price-text" data-cy="inventory-edit-card-case-price-text">
      /{{ 'i18n.inventory.inventoryWorksheet.card.cs' | translate }}
    </p>
  </div>
  <ng-template #productCatchWeight>
    <div
      *ngIf="inventoryItem.productCatchWeightFlag"
      data-cy="inventory-edit-card-price-section"
      class="inventory-price-section"
    >
      <ion-input
        id="price-{{ inventoryId }}-{{ index }}"
        *ngIf="inventoryItem?.unitPrice !== -1; else noUnitPrice"
        data-cy="inventory-edit-card-unit-price-input"
        inputmode="decimal"
        [disabled]="inventoryItem.isSelected"
        [value]="
          priceIsBeingInteracted
            ? inventoryItem.unitPrice
            : (inventoryItem.unitPrice | currency)
        "
        (ionBlur)="handlePriceOverrideEvent($event)"
        (ionFocus)="handlePriceFocus()"
        decimal
        [ngClass]="inventoryItem.isSelected ? 'disabled' : ''"
        globalkeyhandler="input"
      >
      </ion-input>
      <ng-template #noUnitPrice>
        <ion-input
          id="price-{{ inventoryId }}-{{ index }}"
          class="override"
          data-cy="inventory-edit-card-unit-price-not-found-input"
          inputmode="decimal"
          placeholder="$0.00"
          [disabled]="inventoryItem.isSelected"
          (ionBlur)="handlePriceOverrideEvent($event)"
          (ionFocus)="handlePriceFocus()"
          decimal
          [ngClass]="inventoryItem.isSelected ? 'disabled' : ''"
          globalkeyhandler="input"
        >
        </ion-input>
      </ng-template>
      <p
        *ngIf="inventoryItem.productCatchWeightFlag"
        class="price-text"
        data-cy="inventory-edit-card-case-price-text"
      >
        /{{ 'i18n.inventory.inventoryWorksheet.card.lb' | translate }}
      </p>
    </div>
  </ng-template>
</ng-template>

<ng-template #unitPrice>
  <ng-container *ngIf="inventoryItem?.unitPrice !== -1; else notApplicableEA">
    <ion-label
      data-cy="inventory-edit-card-unit-price-text"
      [id]="inventoryItem?.productNumber?.toString() + 'unit-price'"
      class="unit-price"
    >
      <ng-container
        *ngIf="platform !== PlatformEnum.mobile; else unitPriceMobile"
      >
        <span class="medium">{{ inventoryItem?.unitPrice | currency }}</span>
        <br />
        per
        <span class="medium">{{ inventoryItem?.uom }}</span>
      </ng-container>

      <ng-template #unitPriceMobile>
        {{ inventoryItem?.unitPrice | currency }}&nbsp;/{{ inventoryItem?.uom }}
      </ng-template>
    </ion-label>
  </ng-container>
  <ng-template #notApplicableEA>
    <div class="not-found">
      <p
        data-cy="inventory-edit-card-unit-price-text"
        class="unit-price bold not-applicable"
      >
        {{ 'i18n.common.notApplicable' | translate }}
      </p>
    </div>
  </ng-template>
</ng-template>

<!-- Templates for Main Card -->
<ng-template #desktopMain>
  <!-- Checkbox -->
  <ion-col
    data-cy="inventory-edit-card-checkbox-column"
    class="inventory-flex-align-center"
    size="0.4"
  >
    <app-usf-checkbox
      data-cy="inventory-edit-card-checkbox"
      [isSelected]="inventoryItem.isSelected"
      (selectEmitter)="handleSelectionEvent($event)"
    ></app-usf-checkbox>
  </ion-col>
  <!-- Product Data -->
  <ion-col
    data-cy="inventory-edit-card-product-data-column"
    class="inventory-product-data-column"
    size="11.6"
  >
    <ion-row
      data-cy="inventory-edit-card-product-data-container"
      class="ion-align-items-center inventory-product-data-container"
    >
      <!-- Line Number -->
      <ion-col
        data-cy="inventory-edit-card-line-number-column"
        class="inventory-line-number-column"
        offset=".2"
        size=".8"
      >
        <ion-input
          id="lineNumber-{{ inventoryId }}-{{ index }}"
          data-cy="inventory-edit-card-line-number-input"
          inputmode="numeric"
          numeric
          type="text"
          [value]="inventoryItem?.itemSequenceNumber"
          (ionChange)="handleLineNumberChange(lineNumberRef)"
          globalkeyhandler="input"
          #lineNumberRef
        ></ion-input>
      </ion-col>
      <!-- Name, Product Number, Sales Pack Price -->
      <ion-col
        data-cy="inventory-edit-card-details-column"
        class="inventory-product-details-column"
        size="3.3"
        offset="0.1"
      >
        <ng-container [ngTemplateOutlet]="itemDetails"></ng-container>
      </ion-col>
      <!-- Group -->
      <ion-col
        data-cy="inventory-edit-card-group-column"
        class="inventory-group-column"
        size="1.25"
        offset="0.25"
      >
        <ng-container [ngTemplateOutlet]="group"></ng-container>
      </ion-col>
      <!-- Unit Description -->
      <ion-col
        data-cy="inventory-edit-card-unit-description-column"
        class="inventory-unit-description-column"
        size="1.4"
        offset="0.75"
      >
        <ng-container [ngTemplateOutlet]="unitDescription"></ng-container>
      </ion-col>
      <!-- Unit By Case -->
      <ion-col
        data-cy="inventory-edit-card-unit-by-case-column"
        class="inventory-unit-by-case-column"
        size="1.15"
        offset="0.25"
      >
        <ng-container [ngTemplateOutlet]="unitByCase"></ng-container>
      </ion-col>
      <!-- Case Price -->
      <ion-col
        data-cy="inventory-edit-card-case-price-column"
        class="inventory-case-price-column"
        size="1"
        offset="0.15"
      >
        <ng-container [ngTemplateOutlet]="price"></ng-container>
      </ion-col>
      <!-- Unit Price -->
      <ion-col
        data-cy="inventory-edit-card-unit-price-column"
        class="inventory-unit-price-column"
        size="1"
        offset="0.4"
        *ngIf="
          !(
            inventoryItem?.overrideFlag ||
            inventoryItem.productCatchWeightFlag ||
            inventoryItem.productBadPricingCaseFlag ||
            inventoryItem.productBadPricingUnitFlag
          )
        "
      >
        <ng-container [ngTemplateOutlet]="unitPrice"></ng-container>
      </ion-col>

      <ion-col
        data-cy="inventory-edit-card-unit-price-column"
        class="inventory-unit-price-column"
        size="0.5"
        offset="0.4"
        *ngIf="
          inventoryItem?.overrideFlag ||
          inventoryItem.productCatchWeightFlag ||
          inventoryItem.productBadPricingCaseFlag ||
          inventoryItem.productBadPricingUnitFlag
        "
      >
        <ng-container [ngTemplateOutlet]="unitPrice"></ng-container>
      </ion-col>
      <ion-col
        size="0.5"
        *ngIf="
          inventoryItem?.overrideFlag ||
          inventoryItem.productCatchWeightFlag ||
          inventoryItem.productBadPricingCaseFlag ||
          inventoryItem.productBadPricingUnitFlag
        "
      >
        <ng-cotainer [ngTemplateOutlet]="icon"></ng-cotainer>
      </ion-col>
    </ion-row>
  </ion-col>
</ng-template>

<ng-template #tabletMain>
  <!-- Checkbox -->
  <ion-col
    data-cy="inventory-edit-card-checkbox-column"
    class="inventory-flex-align-center"
    size="0.65"
  >
    <app-usf-checkbox
      data-cy="inventory-edit-card-checkbox"
      [isSelected]="inventoryItem.isSelected"
      (selectEmitter)="handleSelectionEvent($event)"
    ></app-usf-checkbox>
  </ion-col>
  <!-- Product Data -->
  <ion-col
    data-cy="inventory-edit-card-product-data-column"
    class="inventory-product-data-column"
    size="11.35"
  >
    <ion-row
      data-cy="inventory-edit-card-product-data-container"
      class="ion-align-items-center inventory-product-data-container"
    >
      <!-- Line Number -->
      <ion-col
        data-cy="inventory-edit-card-line-number-column"
        class="inventory-line-number-column"
        offset=".2"
        size=".8"
      >
        <ion-input
          data-cy="inventory-edit-card-line-number-input"
          inputmode="numeric"
          numeric
          type="text"
          [value]="inventoryItem?.itemSequenceNumber"
          (ionChange)="handleLineNumberChange(lineNumberRef)"
          #lineNumberRef
        ></ion-input>
      </ion-col>
      <!-- Name, Product Number, Sales Pack Price -->
      <ion-col
        data-cy="inventory-edit-card-details-column"
        class="inventory-product-details-column"
        size="3.45"
        offset="0.15"
      >
        <ng-container [ngTemplateOutlet]="itemDetails"></ng-container>
      </ion-col>
      <!-- Unit Description -->
      <ion-col
        data-cy="inventory-edit-card-unit-description-column"
        class="inventory-unit-description-column"
        size="1.7"
        offset="0.25"
      >
        <ng-container [ngTemplateOutlet]="unitDescription"></ng-container>
      </ion-col>
      <!-- Unit By Case -->
      <ion-col
        data-cy="inventory-edit-card-unit-by-case-column"
        class="inventory-unit-by-case-column"
        size="1.55"
        offset="0.15"
      >
        <ng-container [ngTemplateOutlet]="unitByCase"></ng-container>
      </ion-col>
      <!-- Price -->
      <ion-col
        data-cy="inventory-edit-card-case-price-column"
        class="inventory-case-price-column"
        size="1.5"
        offset="0.25"
      >
        <ng-container [ngTemplateOutlet]="price"></ng-container>
      </ion-col>
      <!-- Unit Price -->
      <ion-col
        data-cy="inventory-edit-card-unit-price-column"
        class="inventory-unit-price-column"
        size="1.25"
        offset="0.25"
        *ngIf="
          !(
            inventoryItem?.overrideFlag ||
            inventoryItem.productCatchWeightFlag ||
            inventoryItem.productBadPricingCaseFlag ||
            inventoryItem.productBadPricingUnitFlag
          )
        "
      >
        <ng-container [ngTemplateOutlet]="unitPrice"></ng-container>
      </ion-col>

      <ion-col
        data-cy="inventory-edit-card-unit-price-column"
        class="inventory-unit-price-column"
        size="0.75"
        offset="0.25"
        *ngIf="
          inventoryItem?.overrideFlag ||
          inventoryItem.productCatchWeightFlag ||
          inventoryItem.productBadPricingCaseFlag ||
          inventoryItem.productBadPricingUnitFlag
        "
      >
        <ng-container [ngTemplateOutlet]="unitPrice"></ng-container>
      </ion-col>
      <ion-col
        size="0.5"
        *ngIf="
          inventoryItem?.overrideFlag ||
          inventoryItem.productCatchWeightFlag ||
          inventoryItem.productBadPricingCaseFlag ||
          inventoryItem.productBadPricingUnitFlag
        "
      >
        <ng-cotainer [ngTemplateOutlet]="icon"></ng-cotainer>
      </ion-col>
    </ion-row>
  </ion-col>
</ng-template>

<ng-template #mobileMain>
  <!-- Checkbox -->
  <ion-col
    data-cy="inventory-edit-card-checkbox-column"
    class="inventory-flex-align-center"
    size="1.25"
  >
    <app-usf-checkbox
      data-cy="inventory-edit-card-checkbox"
      [isSelected]="inventoryItem.isSelected"
      (selectEmitter)="handleSelectionEvent($event)"
    ></app-usf-checkbox>
  </ion-col>
  <!-- Product Data -->
  <ion-col
    data-cy="inventory-edit-card-product-data-column"
    class="inventory-product-data-column"
    size="10.75"
  >
    <ion-row
      data-cy="inventory-edit-card-product-data-container"
      class="ion-align-items-center inventory-product-data-container"
    >
      <!-- Line Number -->
      <ion-col
        data-cy="inventory-edit-card-line-number-column"
        class="inventory-line-number-column"
        offset=".6"
        size="1.8"
      >
        <ion-input
          data-cy="inventory-edit-card-line-number-input"
          inputmode="numeric"
          numeric
          type="text"
          [value]="inventoryItem?.itemSequenceNumber"
          (ionChange)="handleLineNumberChange(lineNumberRef)"
          #lineNumberRef
        ></ion-input>
      </ion-col>
      <!-- Product Data -->
      <ion-col
        data-cy="inventory-edit-product-data-column"
        class="inventory-edit-product-data-column"
        offset=".6"
        size="9"
      >
        <!-- Name, Product Number, Sales Pack Price -->
        <ion-row data-cy="inventory-edit-card-product-data-row-1">
          <ion-col
            data-cy="inventory-edit-card-details-column"
            class="inventory-product-details-column"
            size="11.1"
            offset="0.15"
            *ngIf="
              !(
                inventoryItem?.overrideFlag ||
                inventoryItem.productCatchWeightFlag ||
                inventoryItem.productBadPricingCaseFlag ||
                inventoryItem.productBadPricingUnitFlag
              )
            "
          >
            <ng-container [ngTemplateOutlet]="itemDetails"></ng-container>
          </ion-col>
          <ion-col
            data-cy="inventory-edit-card-details-column"
            class="inventory-product-details-column"
            size="9.1"
            offset="0.15"
            *ngIf="
              inventoryItem?.overrideFlag ||
              inventoryItem.productCatchWeightFlag ||
              inventoryItem.productBadPricingCaseFlag ||
              inventoryItem.productBadPricingUnitFlag
            "
          >
            <ng-container [ngTemplateOutlet]="itemDetails"></ng-container>
          </ion-col>
          <ion-col
            size="1.5"
            offset="0.5"
            *ngIf="
              inventoryItem?.overrideFlag ||
              inventoryItem.productCatchWeightFlag ||
              inventoryItem.productBadPricingCaseFlag ||
              inventoryItem.productBadPricingUnitFlag
            "
          >
            <ng-cotainer [ngTemplateOutlet]="icon"></ng-cotainer>
          </ion-col>
        </ion-row>
        <ion-row
          data-cy="inventory-edit-card-product-data-row-2"
          class="inventory-quantities-row"
        >
          <!-- Case Price -->
          <ion-col
            data-cy="inventory-edit-card-case-price-column"
            class="inventory-case-price-column"
            size="6.75"
          >
            <ng-container [ngTemplateOutlet]="price"></ng-container>
          </ion-col>

          <!-- Unit Price -->
          <ion-col
            data-cy="inventory-edit-card-unit-price-column"
            class="inventory-unit-price-column"
            offset="0.5"
            size="4.75"
          >
            <ng-container [ngTemplateOutlet]="unitPrice"></ng-container>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ng-template>
<!-- End Templates -->

<ion-row
  data-cy="inventory-edit-card"
  class="inventory-edit-card"
  [class.selected]="inventoryItem.isSelected"
  [ngClass]="
    platform !== PlatformEnum.desktop
      ? platform === PlatformEnum.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <ng-container
    *ngIf="platform === PlatformEnum.desktop"
    [ngTemplateOutlet]="desktopMain"
  ></ng-container>
  <ng-container
    *ngIf="platform === PlatformEnum.tablet"
    [ngTemplateOutlet]="tabletMain"
  ></ng-container>
  <ng-container
    *ngIf="platform === PlatformEnum.mobile"
    [ngTemplateOutlet]="mobileMain"
  ></ng-container>
</ion-row>
